import { useCallback, useState } from "react";
import SupportPromptGroup from "@amzn/awsui-chat-components-console/support-prompt-group";
import Button from "@amzn/awsui-components-react/polaris/button";
import Box from "@amzn/awsui-components-console/box";
import SpaceBetween from "@amzn/awsui-components-react/polaris/space-between";

import { useChatbot } from "../../../context/chatbot/ChatbotContext";
import { SupportPromptClickEvent } from "../interfaces";
import { getString } from "../../../common/ui-string-labels/ui-strings-utils";
import QuickActionsModal from "./QuickActionsModal";

interface QuickActionsProps {
    onSend: (message: string) => void;
}

const QuickActions = ({ onSend }: QuickActionsProps) => {
    const { quickActions, quickActionsAvailable, quickActionsLoading, saveQuickActions } = useChatbot();
    const [modalVisible, setModalVisible] = useState(false);

    const handleClick = useCallback((event: SupportPromptClickEvent) => {
        const action = quickActions.find((qa) => qa.id === event.detail.id);
        if (action) onSend(action.prompt);
    }, [quickActions, onSend]);

    if (!quickActionsAvailable || quickActionsLoading) return null;

    const items = quickActions.map((qa) => ({ id: qa.id, text: qa.title }));

    return (
        <>
            <SpaceBetween size="xs">
                {quickActions.length > 0 && (
                    <SupportPromptGroup
                        ariaLabel={getString('chatbot.input.quickActionsAriaLabel')}
                        alignment="horizontal"
                        items={items}
                        onItemClick={handleClick}
                    />
                )}
                <Box textAlign="center">
                    <Button
                        data-testid="chatbot-quick-actions-edit"
                        variant="inline-link"
                        iconName="edit"
                        onClick={() => setModalVisible(true)}
                    >
                        {getString('chatbot.quickActions.editButton')}
                    </Button>
                </Box>
            </SpaceBetween>
            <QuickActionsModal
                visible={modalVisible}
                onDismiss={() => setModalVisible(false)}
                items={quickActions}
                onSave={saveQuickActions}
            />
        </>
    );
};

export default QuickActions;
